/* eslint-disable react/prop-types */
/*
 * IMPORT
 */
import React, { useState, useEffect } from "react";
import Navbar from "../../../../components/LandingNavbar/index";
import Footer from "../../../../components/LandingFooter/index";
import { useHistory } from "react-router-dom";
import { useLazyQuery } from "@apollo/client";
import { connect } from "react-redux"; // NPM: React-redux library.
import Loader from "../LandingPage/Loader";
import { tabStyle , videoSmallTextStyle , videoBigTextStyle } from "../../../../components/Styles/index.style"

import _ from "underscore";

/*
 * CHAKRA IMPORTS
 */
import {
  useToast,
  Box,
  Flex,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
  TabIndicator,
  Input,
  Avatar,
} from "@chakra-ui/react";

/*
 * QUERY
 */
import AccountCreatorList from "../__query__/index.creatorList.query";

function Index({ account }) {
  /*
   * States
   */

  const [list, setList] = useState();
  const history = useHistory();
  const toast = useToast();
  const [searchQuery, setSearchQuery] = useState("");

  const [AccountCreatorListQuery, { loading: loadingCreator }] = useLazyQuery(
    AccountCreatorList,
    {
      context: {
        headers: {
          "l-authorization": account.token,
        },
      },
    }
  );

  /*
   * STYLE
   */


  /*
   * Functions
   */
  function formatDate(dateString) {
    const date = new Date(dateString);

    const formattedDate = () =>
      date.toLocaleDateString("en-US", {
        day: "numeric",
        month: "short",
        year: "numeric",
      });

    return formattedDate();
  }

  const handleCreatorList = async () => {
    try {
      const response = await AccountCreatorListQuery({
        variables: {},
      });

      const data = response.data.AccountCreatorList;

      if (!_.isEmpty(data)) {
        setList(data);
      }
    } catch (error) {
      toast({
        title: "Error",
        description: "An error occurred .",
        status: "error",
        duration: 5000, // Milliseconds
        isClosable: true,
      });
    }
  };

  useEffect(() => {
    handleCreatorList();
  }, []);

  // Filter the list based on searchQuery
  const filteredList = list?.filter(
    (data) =>
      data?.userName?.toLowerCase()?.includes(searchQuery?.toLowerCase()) ||
      data?.fullName?.toLowerCase()?.includes(searchQuery?.toLowerCase())
  );

  return (
    <Box bg="#00020A">
      <Navbar />
      <Box
        bg="linear-gradient(110.99deg, rgba(5, 45, 176, 0.2) 0%, rgba(195, 2, 128, 0.2) 100%)"
        w="100%"
        minHeight="100vh"
      >
        <Flex w="100%" h="100px"></Flex>

        <Flex mt="1rem">
          <Flex overflow="scroll" direction="column" w="100%">
            <Tabs padding="0px" width="100%">
              <TabList
                gap="3rem"
                padding="0px"
                style={tabStyle}
                borderColor="none"
                borderBottom="1px solid #505050"
              >
                <Tab
                  ml="3rem"
                  padding="0px"
                  _selected={{ color: "#FFFFFF" }}
                  color="#878992"
                  _focus={{ boxShadow: "none" }}
                >
                  Creator list
                </Tab>
              </TabList>
              <TabIndicator
                mt="-2px"
                height="3px"
                bg="#FFFFFF"
                borderRadius="1px"
              />
              <TabPanels>
                <TabPanel w="100%" padding="0px">
                  <Flex mt="1rem" alignItems="center" justify="center">
                    <Input
                      color="white"
                      placeholder="Search"
                      width="420px"
                      value={searchQuery} // Value of the input field is controlled by searchQuery state
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </Flex>
                  {loadingCreator ? (
                    <Flex align="center" justify="center" w="100%">
                      <Loader />
                    </Flex>
                  ) : (
                    <Flex
                      overflowY="auto"
                      maxHeight="700px"
                      p="35px 24px"
                      direction="column"
                      gap="1rem"
                    >
                      {filteredList?.map((data, index) => (
                        <Flex
                          p="15px"
                          key={data.id}
                          borderRadius="10px"
                          bg="#000000"
                          w="100%"
                          h="190px"
                          gap="1rem"
                          cursor="pointer"
                          _hover={{ bg: "rgba(25, 25, 25, 1)" }}
                          onClick={() =>
                            history.push(`/video-page?id=${data.id}`)
                          }
                        >
                          <Flex color="white">{index + 1}</Flex>
                          <Avatar
                            name={data.fullName}
                            src="https://bit.ly/broken-link"
                          />
                          <Flex gap=".5rem" direction="column">
                            <Text style={videoBigTextStyle}>
                              {data.userName}
                            </Text>
                            <Text style={videoSmallTextStyle}>
                              {data.fullName}
                            </Text>
                          </Flex>
                          <Flex gap="30px" align="center" ml="150px">
                            <Text color="#FFFFFF">
                              Number of videos:{" "}
                              <span>{data?.totalVideoCount}</span>
                            </Text>
                            <Text color="#FFFFFF">
                              Number of followers:{" "}
                              <span>
                                {
                                  data
                                    ?.Follow_Follow_Account__followerIdToAccount
                                    ?.length
                                }
                              </span>
                            </Text>
                            <Text color="#FFFFFF">
                              Number of following:{" "}
                              <span>
                                {
                                  data
                                    ?.Follow_Follow_Account__followingIdToAccount
                                    ?.length
                                }
                              </span>
                            </Text>
                          </Flex>
                          <Flex gap="30px" align="center" ml="150px">
                            <Text color="#FFFFFF">
                              On our platform since :{" "}
                              <span>{formatDate(data?.createdAt)}</span>
                            </Text>
                          </Flex>
                        </Flex>
                      ))}
                    </Flex>
                  )}
                </TabPanel>
              </TabPanels>
            </Tabs>
          </Flex>
        </Flex>
      </Box>
      <Footer />
    </Box>
  );
}
/*
 * EXPORT
 */

const _MapDispatchToProps = (__dispatch) => ({
  AccountUpdate: (u) => __dispatch({ type: "ACCOUNT_UPDATE", Account: u }),
  AccountLogout: () => __dispatch({ type: "ACCOUNT_CLEAR" }),
});

const _MapStateToProps = (state) => ({
  account: state.Account,
});

/*
 * EXPORTS
 */
export default connect(_MapStateToProps, _MapDispatchToProps)(Index);
